const products = [
  {
    id: 'sona-2-cruise',
    name: 'LELO Sona 2 Cruise',
    subtitle: 'Succionador sin contacto',
    price: 'Desde 159 €',
    image: 'https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/7531d1fdae88650bbda51bdf72f36e7a.jpeg',
    tag: 'Más vendido',
    benefits: [
      'Ondas sónicas sin contacto directo',
      'Estimulación profunda y envolvente',
      '12 niveles de intensidad ajustables'
    ]
  },
  {
    id: 'soraya-wave',
    name: 'LELO Soraya Wave',
    subtitle: 'Doble estimulación premium',
    price: 'Desde 219 €',
    image: 'https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/b27d59dc748f408b3c67e6666579f4af.jpeg',
    tag: 'Premium',
    benefits: [
      'Movimiento WaveMotion™ interno',
      'Estimulación dual simultánea',
      'Silicona suave de grado médico'
    ]
  },
  {
    id: 'enigma',
    name: 'LELO Enigma',
    subtitle: 'Succión + vibración profunda',
    price: 'Desde 189 €',
    image: 'https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/2fe7b1743dc6f9741fb56145694f26a8.jpeg',
    tag: 'Innovador',
    benefits: [
      'Combina succión y vibración interna',
      'Tecnología Cruise Control™',
      'Orgasmos más intensos y rápidos'
    ]
  },
  {
    id: 'hugo',
    name: 'LELO Hugo',
    subtitle: 'Placer masculino de próstata',
    price: 'Desde 179 €',
    image: 'https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/3bbf9b2e385c8fa6773d29521ba300df.jpeg',
    tag: 'Para él',
    benefits: [
      'Estimulación de próstata y perineo',
      'Control remoto inalámbrico',
      'Diseño ergonómico y potente'
    ]
  },
  {
    id: 'f1s-v2',
    name: 'LELO F1s V2',
    subtitle: 'Innovación para el placer masculino',
    price: 'Desde 199 €',
    image: 'https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/1dd1b45fb8deafd06dcc9b37bfb5248d.jpeg',
    tag: 'Tech',
    benefits: [
      'Tecnología Sensonic™ de pulsos profundos',
      'Compatible con app LELO para control móvil',
      'Resistente al agua y fácil de limpiar'
    ]
  },
  {
    id: 'tiani-3',
    name: 'LELO Tiani 3',
    subtitle: 'Placer en pareja',
    price: 'Desde 149 €',
    image: 'https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/a0ae63e9ded3ca8e2450b57e257f2ba1.jpeg',
    tag: 'Parejas',
    benefits: [
      'Diseñado para usar en pareja',
      'Control remoto inalámbrico',
      'Estimulación simultánea para ambos'
    ]
  }
];

export default function ProductComparison() {
  return (
    <section id="productos" className="py-16 sm:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-fuchsia-100 text-fuchsia-700 px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            <i className="ri-star-line"></i>
            <span>Los más vendidos</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
            Comparativa de productos LELO
          </h2>
          <p className="text-base sm:text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed px-2">
            Hemos seleccionado los 6 modelos más populares para que encuentres el perfecto para ti
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-product-shop>
          {products.map((product, index) => (
            <div
              key={product.id}
              className="group bg-gradient-to-br from-pink-50/50 to-fuchsia-50/30 rounded-3xl p-6 hover:shadow-2xl hover:shadow-fuchsia-200/50 transition-all duration-300 hover:-translate-y-2 border border-pink-100/50"
            >
              {/* Tag */}
              <div className="flex justify-between items-start mb-4">
                <span className="inline-block bg-gradient-to-r from-fuchsia-500 to-pink-500 text-white text-xs font-bold px-4 py-1.5 rounded-full">
                  {product.tag}
                </span>
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-heart-line text-2xl text-fuchsia-400 hover:text-fuchsia-600 cursor-pointer transition-colors"></i>
                </div>
              </div>

              {/* Product Image */}
              <div className="w-full h-64 mb-6 rounded-2xl overflow-hidden bg-white flex items-center justify-center p-4">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                  loading={index < 3 ? "eager" : "lazy"}
                  width="400"
                  height="400"
                />
              </div>

              {/* Product Info */}
              <div className="space-y-3">
                <h3 className="text-2xl font-bold text-gray-900">{product.name}</h3>
                <p className="text-sm text-fuchsia-600 font-semibold">{product.subtitle}</p>
                <p className="text-3xl font-bold text-gray-900">{product.price}</p>

                {/* Benefits */}
                <ul className="space-y-2 py-4">
                  {product.benefits.map((benefit, index) => (
                    <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-checkbox-circle-fill text-fuchsia-500 text-lg flex-shrink-0 mt-0.5"></i>
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <a
                  href={product.id === 'sona-2-cruise' ? 'https://amzn.to/3L16Rd9' : product.id === 'soraya-wave' ? 'https://amzn.to/4qeaz1W' : product.id === 'enigma' ? 'https://amzn.to/49kintf' : '#'}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="whitespace-nowrap w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-fuchsia-500 to-pink-500 hover:from-fuchsia-600 hover:to-pink-600 text-white px-6 py-4 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
                >
                  <span>Comprar en Amazon</span>
                  <i className="ri-shopping-cart-line text-xl"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">¿No encuentras lo que buscas?</p>
          <a
            href="#"
            className="whitespace-nowrap inline-flex items-center gap-2 text-fuchsia-600 hover:text-fuchsia-700 font-semibold cursor-pointer"
          >
            <span>Ver toda la colección LELO</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
